module.exports = __webpack_public_path__ + "img/averagepin.b78fc3f3.svg";